import React, { useState, useEffect } from "react";
import CurrencyDisplay from "../common/CurrencyDisplay";
import { checkUserRegistered } from "../../services/userService.ts";

export default function BiddingActivityList({ bids }) {
  const [registrationMap, setRegistrationMap] = useState({});

  // whenever bids change, fetch registration state for any new bidder ids
  useEffect(() => {
    if (!bids || bids.length === 0) return;
    const uniqueIds = [...new Set(bids.map((b) => b.bidder?.id).filter(Boolean))];
    uniqueIds.forEach((id) => {
      if (registrationMap[id] === undefined) {
        checkUserRegistered(id)
          .then((isReg) => {
            setRegistrationMap((prev) => ({ ...prev, [id]: isReg }));
          })
          .catch((err) => {
            console.error("failed to fetch registration for user", id, err);
            // treat as not registered on error
            setRegistrationMap((prev) => ({ ...prev, [id]: false }));
          });
      }
    });
  }, [bids]);
  return (
    <div className="bg-[#1e293b] rounded-xl shadow-lg w-full border border-gray-700/50 h-full flex flex-col">
      {/* Header section */}
      <div className="px-4 py-2 border-b border-gray-700">
        <h3 className="font-bold text-sm text-white tracking-wide uppercase">
          BID HISTORY
        </h3>
      </div>

      <div className="p-2 flex-grow flex flex-col">
        <ul className="overflow-y-auto flex-grow h-0 min-h-[150px] space-y-2 custom-scrollbar">
          {bids && bids.length > 0 ? (
            bids.map((bid) => {
              // Format time as "X MINUTES AGO"
              const timeAgo = (() => {
                const now = new Date();
                const bidTime = new Date(bid?.createdAt);
                const diffInMinutes = Math.floor((now - bidTime) / (1000 * 60));
                
                if (diffInMinutes < 1) return "JUST NOW";
                if (diffInMinutes === 1) return "1 MIN";
                if (diffInMinutes < 60) return `${diffInMinutes} MINS AGO`;
                
                const diffInHours = Math.floor(diffInMinutes / 60);
                if (diffInHours === 1) return "1 HR AGO";
                return `${diffInHours} HRS AGO`;
              })();

              return (
                <li
                  key={bid.id}
                  className="flex items-center justify-between py-1 px-2 hover:bg-white/5 rounded"
                >
                  {/* Bidder name and time */}
                  <div className="flex-1">
                    <div className="font-semibold text-white text-xs">
                     
                      {bid?.bidder?.id && (
                        <span >
                          {registrationMap[bid.bidder.id] ? "OnLine User" : "OnSite User"}
                        </span>
                      )}
                    </div>
                    <div className="text-[10px] text-gray-400 uppercase">
                      {timeAgo}
                    </div>
                  </div>

                  {/* Bid amount */}
                  <div className="font-bold text-sm text-white">
                    $ {bid.amount.toLocaleString()}
                  </div>
                </li>
              );
            })
          ) : (
            <li className="text-center text-gray-400 py-4">
              <div className="text-xs">No bids yet</div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
